module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/save-money-as-a-wedding-guest-9bc3b1a762d22ec514fae44158491058.jpg";